import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { State } from '../../shared/core/state';
import { Store } from '@ngrx/store';

import * as UserActions from '../../shared/core/state/users/user.actions';
import { map, Observable, takeLast, takeWhile, timer } from 'rxjs';

//TODO:update this component with verify-otp
@Component({
    selector: 'black-verify-user',
    templateUrl: './verify-user.component.html',
    styleUrls: ['./verify-user.component.css'],
    standalone: false,
    host: {
      ngSkipHydration: 'true',
    },
})
export class VerifyUserComponent implements OnInit, AfterViewInit {
  private fb = inject(NonNullableFormBuilder);
  private store = inject<Store<State>>(Store);

  otpForm: FormGroup;
  otpError: string | null = null;

  constructor() {
    this.otpForm = this.fb.group({
      otp: [''],
    });
  }

  resendEnable = false;

  timeRemaining$ = new Observable<number>();

  ngAfterViewInit(): void {
    this.store
      .select((state) => state.users.otp)
      .subscribe((otp) => {
        if (otp.expiresOn) {
          this.resendEnable = false;

          const leftTime =
            (otp.expiresOn.getTime() - new Date().getTime()) / 1000;

          this.timeRemaining$ = timer(0, 1000).pipe(
            map((n) => (leftTime - n) * 1000),
            takeWhile((n) => n >= 0)
          );

          this.timeRemaining$.pipe(takeLast(1)).subscribe(() => {
            this.resendEnable = true;
          });
        }
      });
  }

  sendCode = () => {
    this.store.dispatch(
      UserActions.sendVerificationCode({ username: undefined })
    );
  };

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    this.store
      .select((state) => state.users.error)
      .subscribe((msg) => {
        this.otpError = msg;
      });

    this.sendCode();
  }

  get otpLength() {
    return this.otpForm.get('otp')?.value.length;
  }

  get otpValue() {
    return this.otpForm.get('otp')?.value;
  }

  submit() {
    this.otpError = null;

    if (this.otpValue) {
      this.store.dispatch(UserActions.verifyUser({ code: this.otpValue }));
    }
  }
}
